// Spanish

const lang = {
  gateMediaPreviewHeader: 'También te puede interesar',
  loadmore: 'Mostrar más',
  nextMedia: 'Próximos medios',
  previousMedia: 'Medios anteriores',
  closePost: 'Cerrar publicación',
  nextPost: 'Publicación siguiente',
  previousPost: 'Publicación anterior',
  outOfStock: 'Agotado',
  numberOfReviews(n) {
    return n === 1 ? 'opinión' : 'opiniones'
  },
  reportFormField: 'Introduzca un mensaje',
  reportPost: 'Publicación anterior',
  reportFormTitle: '¿Quieres denunciar esta imagen?',
  reportFormDetails:
    'Si crees que la imagen es inapropiada, ilegal o infringe los derechos de alguna persona, puedes denunciar el contenido. Si denuncias la imagen / texto, se notificará a los moderadores de contenido y se tomarán las medidas apropiadas.',
  reportFormMessagePlaceholder: 'Indique el motivo de su informe',
  reportFormMessageLabel: 'Mensaje',
  reportFormEmailLabel: 'Email',
  reportFormSubmitButtonText: 'Enviar informe',
  reportFormCancelButtonText: 'Cancelar',
  reportFormSentTitle: '¡Gracias por su informe!',
  reportFormSentCloseButtonText: 'Cerrar',
  cardAndTileAriaLabel: 'Lista de publicaciones de cuentas en varias redes sociales',
  carouselAriaLabel: 'Carrusel con publicaciones de cuentas en redes sociales',
  singleAriaLabel: 'A continuación se muestra una publicación de una cuenta en las redes sociales',
  poweredBy: 'Con tecnología de Flowbox',
  postAltText: (userName, date) => {
    const publishedString = date ? ` publicada el ${date}` : ''
    const createdByString = userName ? ` por ${userName}` : ''
    return `Foto${createdByString}${publishedString}`
  },
  uploadYourMedia: 'Sube tu contenido',
  openTheGate: 'Abrir el diálogo',
  gridRoleDescription: 'cuadrícula',
  carouselRoleDescription: 'carrusel',
  tiktokVideoAriaLabel: 'Video de TikTok incrustado. Pulsa reproducir para ver el contenido.',
  feedThumbnailAriaLabel: (postIndex, maxPosts) =>
    `Miniatura del medio ${postIndex + 1} de ${maxPosts}, abre diálogo con contenido de redes sociales y lista de productos destacados.`,
  carouselControlButtonsAriaLabel: 'Botones de control del carrusel',
  gateCarouselIndicatorAriaLabel: (mediaIndex, maxMedia) =>
    `Medio ${mediaIndex + 1} de ${maxMedia}`,
  showMoreCaption: 'Mostrar más descripción',
  showLessCaption: 'Mostrar menos descripción',
  originalPrice: (price) => `Precio original: ${price}`,
  salesPrice: (price) => `Precio de oferta: ${price}`,
  postPublishedBy: 'Publicación realizada por',
  mediaAltText: (isVideo, username, date, altText) => {
    const mediaType = isVideo ? 'Vídeo' : 'Imagen'
    const user = username ? `${username}` : 'usuario desconocido'
    const publishDate = date ? `el ${date}` : ''
    return `${mediaType} publicado por ${user} ${publishDate}. Puede ser ${altText}`
  },
  gateSlideAriaLabel: (postIndex, maxPosts) => `Publicación ${postIndex + 1} de ${maxPosts}.`,
}

export default lang
